import React from 'react';
import {
    Routes,
    Route,
    useNavigate,
    Navigate,
    useLocation
} from 'react-router-dom';
import { FaChartLine, FaBalanceScale, FaDollarSign } from 'react-icons/fa';
import Services from '../Common/Services/page';
import ProductionValue from './ProductionValue';
import ProductionQuantity from './ProductionQuantity';
import IncreaseInValues from './IncreaseInValues';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Situação de Produção',
        path: '/governanceroom/dashboardsiasus/production/production-situation',
        icon: <FaChartLine style={{ marginRight: '5px' }} />
    },
    {
        title: 'Produção - Quantidade',
        path: '/governanceroom/dashboardsiasus/production/production-quantity',
        icon: <FaBalanceScale style={{ marginRight: '5px' }} />
    },
    {
        title: 'Produção - Valor',
        path: '/governanceroom/dashboardsiasus/production/production-value',
        icon: <FaDollarSign style={{ marginRight: '5px' }} />
    },
    {
        title: 'Incremento de Valores',
        path: '/governanceroom/dashboardsiasus/production/increments',
        icon: <FaDollarSign style={{ marginRight: '5px' }} />
    }
];

const titlesMap = {
    '/governanceroom/dashboardsiasus/production/production-situation':
        'Situação de Produção',
    '/governanceroom/dashboardsiasus/production/production-quantity':
        'Produção - Quantidade',
    '/governanceroom/dashboardsiasus/production/production-value':
        'Produção - Valor',
    '/governanceroom/dashboardsiasus/production/increments':
        'Incremento de Valores'
};

const Production = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsiasus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titlesMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="production-situation"
                            element={
                                <Services
                                    module={{
                                        sectionTitle: 'do Indicativo da Situação'
                                    }}
                                    queryConfig={{
                                        key: 'production-situation-services',
                                        url: 'governanceroom/dashboard/services/production/situation'
                                    }}
                                />
                            }
                        />
                        <Route
                            path="production-quantity"
                            element={<ProductionQuantity />}
                        />
                        <Route
                            path="production-value"
                            element={<ProductionValue />}
                        />
                        <Route
                            path="increments"
                            element={<IncreaseInValues />}
                        />
                        <Route
                            path="/"
                            element={
                                <Navigate to="production-situation" replace />
                            }
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};

export default Production;
